// src/socket.js
import { io } from "socket.io-client";

// ✅ Hardcoded local backend URL
export const socket = io("http://localhost:5000", {
  transports: ["websocket"],
  withCredentials: true,
});
